import { Layout } from 'antd';
import React from 'react'
const { Footer } = Layout;
function FooterLayout() {
    const footerStyle = {
        textAlign: "center"
    }
    return (
        <Footer style={{ textAlign: "center", margin: 0, padding: 0 }}>
            © 2025 All Rights Reserved Ctrade USA Powered By <a href={"https://avantgardetech.us/"} target='_blank' rel="noopener noreferrer"> Avantgrade Technology</a>
        </Footer >
    )
}

export default FooterLayout